import { ValidatorFn } from '@angular/forms';

export const requiredNotBlank: ValidatorFn = (control) =>
  typeof control.value === 'string' && control.value.trim().length > 0 ? null : { required: true };
